var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component"},[(_vm.isAuthenticated)?[_c('logout-button',{attrs:{"depressed":"","fab":"","small":""}})]:[_c('v-btn',{attrs:{"to":{'name': 'login-login'}}},[_c('v-icon',[_vm._v("mdi-checkmark")])],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }